<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M15.223 4.298a1.11 1.11 0 01.358-.22 1.182 1.182 0 01.843 0c.133.05.255.125.357.22 2.728 2.522 5.75 3.758 9.119 3.758l.055.001c.271.013.53.118.723.296.206.19.322.448.322.717v6.086c0 5.199-2.295 9.072-6.792 11.524-1.982 1.193-3.712 1.512-5.343 1.217a7.053 7.053 0 01-1.065-.282v.008l-.183-.075a9.291 9.291 0 01-.937-.415C7.597 24.717 5 20.686 5 15.156V9.07c0-.269.116-.527.322-.717a1.15 1.15 0 01.778-.297c3.366 0 6.389-1.238 9.123-3.758z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'securityShieldFilled'
}
</script>
